// extracted by mini-css-extract-plugin
export var modal = "_gp-0";